<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title style="background: #1ba060;" class="text-h5 darken-3 white--text">
            Confirmar seleccion de proyecto
          </v-card-title>
  
          <v-card-text> 
            <!-- <p class="text-center mt-4"> El proyecto seleccionado será aprobado y trabajado en la sede: <b>{{ $store.state.CARGO.sede.nombre }}</b> </p> -->
            <p class="text-center mt-4"> El proyecto seleccionado será revisado y, de ser aprobado, se lo habilitara para crear el programa en la sede: <b>{{ $store.state.CARGO.sede.nombre }}</b> </p>
            <p class="text-center blue--text">{{ proy.programa_nombre }}</p>
            <p class="mb-0">
              <b>NOTA:</b>
              Solo se puede seleccionar el proyecto una sola ves por sede
            </p>
            <!-- <p class="mt-0">Despues de confirmar, un academico nacional se encarga de aprobar el proyecto para proceder a la habilitacion de crear el programa</p> -->
            <p class="mt-2"> La aprobación del proyecto por un académico nacional de proyectos permitirá al <b>responsable de marketing</b> de sede la creación de la fechas de campaña y luego la creación del programa <b>por el responsable academico</b> para realizar las inscripciones. </p>
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#1ba060" dark :disabled="loading" @click="enviar()"> Seleccionar </v-btn>
            <v-btn color="red" outlined @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>
import { seleccionar_para_dbs } from '@/views/oferta_academica/servicios/seleccionService.ts';

export default {
    data() {
        return {
            loading: false,
            dialog: false,
            input: {},
            proy: {},
        };
    },
    methods: {
        async openmodal(row,lista_oferta='') { 
          this.proy = row
            const sede = this.$store.state.CARGO.sede
            const user = this.$store.state.DATA_USER 
            const pv_id = row.proyecto_vinculado? row.proyecto_vinculado : row.pv_id;
            const pu_id = row.programa_universidad_max_id? row.programa_universidad_max_id: row.id;
            this.input = {
                proyecto_vinculado_id: pv_id,
                programa_universidad_id: pu_id,
                proyecto_id: row.proyecto_id,
                sede_portal_id: sede.id,
                sede_portal_name: sede.nombre,
                coordinador_usuario_id: user.id,
                postgrado_id: row.postgrado_id,
                lista_de_oferta: lista_oferta
            } 
            this.dialog = true;

            // window.console.log('roewwww',row,this.input);
        },

        async enviar(){
            this.loading = true 
            const r = await seleccionar_para_dbs(this.input);
            
            if(r && r.seleccionar_para_dbs){ 
              this.$root.$notify.show('exito', { color: '#009800', x: 'left' });
              this.dialog = false
              this.$emit('onsuccess')
            }else if(r && r.graphQLErrors) {
              let m = ''
              r.graphQLErrors.forEach(x => {
                m += x.message
              }); 
              if(m.includes('Duplicate entry')){
                m = 'ya fue seleccionado para esta sede'
              }
              if(!m) m = r.message; 
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }else{
              const m = JSON.stringify(r);
              window.console.log('mmm',m);
              
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
              
            }
            
            this.loading = false
        }
    }
};
</script>
  